// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage, intlShape } from 'react-intl';
import analytics from '../../../../../analytics';

import style from './ResultBox.scss';

import type { SearchProduct } from '../../duck';
import type { LocaleState } from '../../../../locale/duck';

type Props = {
  +product: SearchProduct;
  +locale: LocaleState;
};

export default class ResultBox extends Component<Props> {

  handleClickProduct = (url: string) => {
    const { locale } = this.props;
    analytics.fireCustomEvent('Product Search Clicked', {
      category: 'Product Search',
      action: 'Clicked',
      label: url,
      user_type: 'purchaser',
      user_referrer: window.localStorage.getItem('userReferrer') || '',
      landing_url: window.localStorage.getItem('landingUrl') || '',
      domain_country: locale.domainCountry,
      url: url,
    });
  };

  render() {
    const { product } = this.props;
    let link = `/new-order/product?initialQuery=${product.url}`;
    return (
      <Fragment>
        <Link to={link}
              className={style.orderBox}
              onClick={(e: Event) => this.handleClickProduct(product.url)}>
          <article className={style.wrapper}>
            <img className={style.imageWrap}
                 src={product.image} alt="image"/>
            <p className={style.name}>{product.name}</p>
            {!!product.price &&
            <p className={style.price}>${product.price}</p>}
          </article>
        </Link>
      </Fragment>);
  }
}

ResultBox.propTypes = {
  product: PropTypes.object.isRequired,
  locale: PropTypes.object.isRequired,
};

ResultBox.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/SearchStep/components/ResultBox/ResultBox.jsx